interface LocationInputProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}

export const LocationInput: React.FC<LocationInputProps> = ({ label, placeholder, value, onChange }) => {
  return (
   
   <div className="flex flex-col gap-[0.11vw]"> 
      <label className="font-inter font-[400] text-[1.992vh] text-[#000] tracking-wide pl-[0.44vw]">
        {label}
      </label>
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: "0.33vw 0.44vw",
          height:"4.5vh",
          fontSize: "1.765vh",
          fontFamily :"inter",
          fontWeight: "300",
          backgroundColor: "#fff",
          border: "1px solid #9d9d9d",
          borderRadius: "0.44vw",
          color: "#000",
          outline: "none",
          boxShadow: "0 0.05vw 0.11vw 0 rgba(0, 0, 0, 0.05)",
          margin: 0,
          boxSizing: "border-box",
        }}
        className="w-full text-black  text-[1.765vh] placeholder:!text-[#000] placeholder:text-[1.765vh]  "
      />
    </div>
  );
};